import { gsap } from "gsap";
const accordionBtns = document.querySelectorAll('button.accordion-btn');
const prefersReducedMotion = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

// Change attributes of accordion buttons/content (accessibility)
const changeAttributes = (activeBtn, activeContent, newBtn, newContent) => {
    activeBtn.setAttribute('aria-expanded', 'false');
    newBtn.setAttribute('aria-expanded', 'true');
    activeContent.setAttribute('aria-hidden', 'true')
    newContent.setAttribute('aria-hidden', 'false')
}

// Mobile - Slide down + Wipe stagger accordion animation
const accordionAnimMobile = (activeBtn, activeContent, newBtn, newContent) => {
    let timeline = gsap.timeline({defaults: {duration:0.3}});
    let newContentEls = newContent.querySelectorAll('.accordion-item')

    timeline.to(activeContent, {opacity: 0, height: '0', duration:0.3});
    timeline.set(newContent, {opacity: 1, height: '0'});
    timeline.set(newContentEls, {clipPath: 'inset(0 100% 0 0)'});
    timeline.call(changeAttributes, [activeBtn, activeContent, newBtn, newContent], '>')
    timeline.to(newContent, {height: 'auto'}, '>0.1');
    timeline.to(newContentEls, {clipPath: 'inset(0 0% 0 0)', ease:'cubic-bezier(.87,0,.13,1)', stagger: 0.1}, '>-0.1');
}

// Desktop - Wipe stagger accordion animation
const accordionAnimWipeStagger = (activeBtn, activeContent, newBtn, newContent) => {
    let timeline = gsap.timeline({defaults: {duration:0.5, ease:'cubic-bezier(.87,0,.13,1)'}});
    let contentContainer = document.querySelector('.accordion-content-container');
    let contentContainerHeight = contentContainer.offsetHeight;
    let activeContentEls = activeContent.querySelectorAll('.accordion-item')
    let newContentEls = newContent.querySelectorAll('.accordion-item')

    timeline.to(activeContentEls, {clipPath: 'inset(0 0 0 100%)', duration:0.3});
    timeline.set(contentContainer, {height:contentContainerHeight});
    timeline.set(newContentEls, {clipPath: 'inset(0 100% 0 0)'});
    timeline.call(changeAttributes, [activeBtn, activeContent, newBtn, newContent], '>')
    timeline.to(contentContainer, {height:'auto'}, '>0.1');
    timeline.to(newContentEls, {clipPath: 'inset(0 0% 0 0)', stagger: 0.1}, '<');
}

// Click listener for non-active accordion buttons
for (let accordionBtn of accordionBtns) {
    accordionBtn.addEventListener('click', () => {
        let isAriaExpanded = (accordionBtn.getAttribute('aria-expanded') === 'true' ? true : false)

        if (!isAriaExpanded) {
            let isMobile = window.innerWidth < 900;
            let accordionContent = (!!isMobile ? document.querySelector('.accordion-container.mobile-var') : document.querySelector('.accordion-container.desktop-var'));
            let activeBtn = accordionContent.querySelector('.accordion-btn[aria-expanded="true"]')
            let activeContent = accordionContent.querySelector('.accordion-content[aria-hidden="false"]')
            let newContentID = accordionBtn.getAttribute('aria-controls')
            let newContent = accordionContent.querySelector(`#${newContentID}`)

            if (!!prefersReducedMotion) {
                changeAttributes(activeBtn, activeContent, accordionBtn, newContent)
            } else {
                if (!!isMobile) {
                    accordionAnimMobile(activeBtn, activeContent, accordionBtn, newContent)
                } else {
                    accordionAnimWipeStagger(activeBtn, activeContent, accordionBtn, newContent)
                }
            }
        }
    })
}